/* istanbul ignore file */
import axios from 'axios';
import { UploadContractDocumentFileResult } from '../types/generated/uploadContractDocumentFileResult';

export interface UploadContext {
    arrayElementId?: string;
    parentArrayElementId?: string;
    relativeFieldPath: string;
}

export const uploadDocumentFile = async (
    formId: string,
    language: string,
    file: File,
    context: UploadContext
): Promise<UploadContractDocumentFileResult> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('relativeFieldPath', context.relativeFieldPath);

    if (context.arrayElementId) {
        formData.append('arrayElementId', context.arrayElementId);
    }
    if (context.parentArrayElementId) {
        formData.append('parentArrayElementId', context.parentArrayElementId);
    }

    return axios
        .post(`/file/upload/contract/${formId}/${language}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        .then((res) => res.data)
        .catch((error) => {
            throw error;
        });
};
